import { getGeoValue, TGeoValue, TJsonQuery } from '../../../packages/JsonQuery';

export function removeDistrictFromJsonQuery(jsonQuery: TJsonQuery, id: number): TGeoValue[] {
  const geo = getGeoValue()(jsonQuery);

  if (!geo) {
    return [];
  }

  const value = geo.filter(item => item.type !== 'district' || (item.type === 'district' && item.id !== id));

  return value.length === 0 ? [] : value;
}
